import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import transformPagination from 'common/transformPagination'
import { toParam } from 'common/utils/urls/param'

export const teamMemberService = service
  .enhanceEndpoints({ addTagTypes: ['TeamMember'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createTeamMember: builder.mutation<
        Res['teamMember'],
        Req['createTeamMember']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'TeamMember' }],
        query: (query: Req['createTeamMember']) => ({
          body: query,
          method: 'POST',
          url: `partners/users`,
        }),
      }),
      deleteTeamMember: builder.mutation<
        Res['teamMember'],
        Req['deleteTeamMember']
      >({
        invalidatesTags: [{ id: 'LIST', type: 'TeamMember' }],
        query: (query: Req['deleteTeamMember']) => ({
          body: query,
          method: 'DELETE',
          url: `partners/users/${query.id}`,
        }),
      }),
      getTeamMember: builder.query<Res['teamMember'], Req['getTeamMember']>({
        providesTags: (res) => [{ id: res?.id, type: 'TeamMember' }],
        query: (query: Req['getTeamMember']) => ({
          url: `partners/users/${query.id}`,
        }),
      }),
      getTeamMembers: builder.query<Res['teamMembers'], Req['getTeamMembers']>({
        providesTags: [{ id: 'LIST', type: 'TeamMember' }],
        query: (query) => ({
          url: `partners/users?${toParam(query)}`,
        }),
        transformResponse: (res, _, req) =>
          transformPagination(req, res) as any,
      }),
      updateTeamMember: builder.mutation<
        Res['teamMember'],
        Req['updateTeamMember']
      >({
        invalidatesTags: (res) => [
          { id: 'LIST', type: 'TeamMember' },
          { id: res?.id, type: 'TeamMember' },
        ],
        query: (query: Req['updateTeamMember']) => ({
          body: query,
          method: 'PUT',
          url: `partners/users/${query.id}`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

export async function getTeamMembers(
  store: any,
  data: Req['getTeamMembers'],
  options?: Parameters<
    typeof teamMemberService.endpoints.getTeamMembers.initiate
  >[1],
) {
  return store.dispatch(
    teamMemberService.endpoints.getTeamMembers.initiate(data, options),
  )
}
export async function createTeamMember(
  store: any,
  data: Req['createTeamMember'],
  options?: Parameters<
    typeof teamMemberService.endpoints.createTeamMember.initiate
  >[1],
) {
  return store.dispatch(
    teamMemberService.endpoints.createTeamMember.initiate(data, options),
  )
}
export async function deleteTeamMember(
  store: any,
  data: Req['deleteTeamMember'],
  options?: Parameters<
    typeof teamMemberService.endpoints.deleteTeamMember.initiate
  >[1],
) {
  return store.dispatch(
    teamMemberService.endpoints.deleteTeamMember.initiate(data, options),
  )
}
export async function getTeamMember(
  store: any,
  data: Req['getTeamMember'],
  options?: Parameters<
    typeof teamMemberService.endpoints.getTeamMember.initiate
  >[1],
) {
  return store.dispatch(
    teamMemberService.endpoints.getTeamMember.initiate(data, options),
  )
}
export async function updateTeamMember(
  store: any,
  data: Req['updateTeamMember'],
  options?: Parameters<
    typeof teamMemberService.endpoints.updateTeamMember.initiate
  >[1],
) {
  return store.dispatch(
    teamMemberService.endpoints.updateTeamMember.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateTeamMemberMutation,
  useDeleteTeamMemberMutation,
  useGetTeamMemberQuery,
  useGetTeamMembersQuery,
  useUpdateTeamMemberMutation,
  // END OF EXPORTS
} = teamMemberService

/* Usage examples:
const { data, isLoading } = useGetTeamMembersQuery({ id: 2 }, {}) //get hook
const [createTeamMembers, { isLoading, data, isSuccess }] = useCreateTeamMembersMutation() //create hook
teamMemberService.endpoints.getTeamMembers.select({id: 2})(store.getState()) //access data from any function
*/
